
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Modal } from 'office-ui-fabric-react/lib/Modal';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { DefaultButton, PrimaryButton, IconButton } from 'office-ui-fabric-react/lib/Button';

import PanelTitle from './PanelTitle';

const classNames = mergeStyleSets({
    root: {
        padding: 16
    },
    title: {
        paddingBottom: 16
    },
    content: {
        paddingRight: 8,
        marginBottom: 8,
    },
    closeIcon: {
    }
});

const DialogButton = ({onClick, primary, title, value}) => {

    const handleClick = () => {
        if (onClick) {
            onClick(value);
        }
    }

    return (primary)
        ? <PrimaryButton text={title} onClick={handleClick} />
        : <DefaultButton text={title} onClick={handleClick} />;
}

const Dialog = ({children, buttons, open, onDismiss, title}) => {

    const handleClose = () => {
        if (onDismiss) {
            onDismiss(false);
        }
    }

    const handleCloseClick = (value) => {
        if (onDismiss) {
            onDismiss(value);
        }
    }

    const renderButtons = () => {
        buttons = buttons || [{primary: true, title: 'Zavřít', value: false}]

        return buttons.map((item, index) => {
            return (
                <DialogButton {...item} key={index} onClick={handleCloseClick} />
            );
        });
    }

    return (
        <Modal
            className={classNames.root}
            isOpen={open}
            isModeless={false}
            isDarkOverlay={true}
            dragOptions={false}
            onDismiss={handleClose}
        >
            <Stack className={classNames.root}>
                <Stack horizontal className={classNames.title}>
                    <Stack.Item grow>
                        <PanelTitle title={title} />
                    </Stack.Item>
                    <IconButton
                        styles={classNames.closeIcon}
                        iconProps={{iconName: 'Cancel'}}
                        ariaLabel="Zavřít"
                        onClick={handleClose}
                    />
                </Stack>
                <Stack.Item className={classNames.content}>
                    {children}
                </Stack.Item>
                <Stack horizontal reversed>
                    {renderButtons()}
                </Stack>
            </Stack>
        </Modal>
    );
}

export default Dialog;
